import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import Emitter from '../game/Emitter';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import Game from './Game';
import LocalizationSoundAssetKeys from '../Localization-SoundAssetKeys';

export default class Intro extends Phaser.Scene
{
    static get KEY() { return 'Intro'; }

    constructor()
    {
        super({ key: (Intro).KEY });
    }

    init()
    {
        this.titleSprite = null;
        this.inputField = null;
        this.points = [];
        this.santa = null;
        this.title = null;
        this.monster = null;
        // reset shortest bonus time
        gameData.BEST_BONUS_TIME = 99999;
    }

    create()
    {
        let width = this.scale.width;
        let height = this.scale.height;
        this.points = [];

        ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._intro_background, this).setOrigin(0);

        this.addFish();
        this.addRays();

        this.title = ABCyaPhaser.Images.addImage(width / 2 - 1000, height / 2 - 80, UIAssetKeys._title, this);
        ABCyaPhaser.Tweens.addTween(this.title, 600, { scaleX: 1.4, scaleY: 0.7, yoyo: true, repeat: 1 }, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(this.title, 2400, { x: this.title.x + 1000 }, Phaser.Math.Easing.Linear, () => this.oscillate(this.title));

        this.button = ABCyaPhaser.Buttons.addSimpleButton(width / 2, height / 2 + 205, "go_button", null, this.goClicked.bind(this), this, { textureAtlas: "piecesData2" }).setScale(1.2);
        ABCyaPhaser.Tweens.addTween(this.button, 500, { delay: 100, scale: 1.7, yoyo: true }, Phaser.Math.Easing.Bounce.Out, () => this.float(this.button));

        ABCyaPhaser.Audio.playOneShot(LocalizationSoundAssetKeys._title, this, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

        this.soundLoop = ABCyaPhaser.Audio.createSound(this);
        ABCyaPhaser.Audio.playSound(SoundAssetKeys._jingle, this.soundLoop, 1, true);
        this.events.once(Phaser.Scenes.Events.SHUTDOWN, () => this.soundLoop.destroy());
    }

    addFish()
    {
        this.doFishMotion("fish1", -200, 300, 7400);
        this.doFishMotion("fish2", 1500, 100, 9400);
        this.doFishMotion("fish3", 1500, 200, 5400);
        this.doFishMotion("fish4", 1500, 400, 11400);
    }

    doFishMotion(spriteName, startX, startY, time)
    {
        let sprite = ABCyaPhaser.Images.addImage(startX, startY, spriteName, this, "piecesData2");

        let endX = -200;
        if (startX < 0)
        {
            endX = 1500;
        }

        ABCyaPhaser.Tweens.addTween(sprite, time, { x: endX, repeat: -1 }, Phaser.Math.Easing.Linear);
        ABCyaPhaser.Tweens.addTween(sprite, 600, { scaleX: 1.1, scaleY: 0.9, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Linear);
    }

    addRays()
    {
        this.makeRay("ray1", 120);
        this.makeRay("ray2", 230, 305);
        this.makeRay("ray3", 430, 320);
        this.makeRay("ray4", 520, 300);
        this.makeRay("ray5", 640, 300);
        this.makeRay("ray6", 720, 240);
    }

    makeRay(spriteName, startX, startY)
    {
        let sprite = ABCyaPhaser.Images.addImage(startX, startY, spriteName, this).setAlpha(0.4);
        ABCyaPhaser.Tweens.addTween(sprite, 1500, { alpha: 0.1, yoyo: true, repeat: -1, delay: Phaser.Math.Between(300, 1300) }, Phaser.Math.Easing.Linear);
    }

    oscillate(sprite)
    {
        ABCyaPhaser.Tweens.addTween(sprite, 1000, { scaleX: 1.02, scaleY: 0.98, yoyo: true, repeat: -1 }, Phaser.Math.Easing.Linear);
    }

    float(sprite)
    {
        this.tweens.timeline({
            tweens:
                [
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x + 4, y: this.button.y }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x, y: this.button.y - 4 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x - 4, y: this.button.y }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x, y: this.button.y + 4 }, Phaser.Math.Easing.Linear),
                    ABCyaPhaser.Tweens.createTween(sprite, 800, { x: sprite.x, y: this.button.y }, Phaser.Math.Easing.Linear),
                ],
            loop: true
        });
    }

    goClicked()
    {
        this.button.disableInteractive();

        this.addBubbles();

        this.time.delayedCall(1300, this.doTransition, null, this);
        this.time.delayedCall(2100, this.cleanUp, null, this);
    }

    addBubbles()
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._bubbles, this);

        this.emitter = new Emitter(this, 3);
        this.emitter.x = 0;
        this.emitter.y = this.scale.height + 10;

        this.add.existing(this.emitter);
        this.emitter.emitParticles("bubbles", 100);
    }

    doTransition()
    {
        ABCyaPhaser.Tweens.addTween(this.cameras.main, 800, { x: -1200 }, Phaser.Math.Easing.Linear);
    }

    cleanUp()
    {
        this.tweens.killAll();
        this.time.removeAllEvents();

        this.scene.start(Game.KEY);
    }
}